export default __webpack_public_path__ + "static/media/Buffer.6f773836.svg";